import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    content: {
    },
    container: {
        overflowY: 'auto',
        padding: theme.spacing(1),
        height: '100%',
        position: 'relative'
    },
    containerComp: {
        padding: 0,
        position: 'relative'
    },
    descricao: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(1.5),
        borderRadius: theme.shape.borderRadius,
        boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.1)',
        '& strong': {
            color: theme.palette.primary.main
        }
    },
    subtitle: {
        fontWeight: 700,
        fontSize: '1rem'
    },
    whatsappIcon: {
        margin: 0
    },
    root: {
        height: '100%'
    }
}))